import {useState,useEffect} from 'react';
import {makePostRequest} from '../../services/httpHelper'
import { Card } from 'react-bootstrap';
import {  CircularProgress } from '@mui/material';
import { useNavigate, useParams } from 'react-router-dom';



const VerifyPhoneNumber = ({msisdn})=>{

    const[verificationCode,setVerificationCode]=useState(null);
    const[error,setError]=useState(null);
    const[isSubmitting,setIsSubmitting]=useState(false);
    const[isSuccess,setIsSuccess]=useState(false);
    const [countdown, setCountdown] = useState(60);
  const [canResend, setCanResend] = useState(false);

    const navigate =useNavigate();


   const onClose=()=>{
    navigate('/')
   }

    const handleChange =(e)=>{
        setVerificationCode(e.target.value)

    }

    const handleSubmit =async(e)=>{
        e.preventDefault();
        if(verificationCode===null){
            setError('Enter Verification Code');
            return;
        }

        setIsSubmitting(true)
        const data ={
            verificationCode:verificationCode,
            msisdn:msisdn,

          
        }

        const res = await makePostRequest('verify-deletion-of-personal-data-request',data);
        if(res && res.errorType){
            setIsSubmitting(false);
          if(res.errorType === 'validation'){
            setError(res.errorMessage)           
  
          }
                 
    
      else{
          setError(res.errorMessage);
        }
          }else{
                       
            setIsSubmitting(false);
            setIsSuccess(true)

            
          }

        
    }

    useEffect(() => {
      if (countdown > 0) {
        const timer = setTimeout(() => setCountdown(countdown - 1), 1000);
        return () => clearTimeout(timer);
      } else {
        setCanResend(true);
      }
    }, [countdown]);

    const handleResend = (e) => {
      e.preventDefault();
      if (canResend) {
        resendVerificationCode(e);
        setCountdown(60);
        setCanResend(false);
      }
    }
    const resendVerificationCode =async(e)=>{
      e.preventDefault();
   
      setIsSubmitting(true)
      const data ={
          msisdn:msisdn,

        
      }

      const res = await makePostRequest('delete-personal-data-resend-code',data);

      if(res.errorMessage){
        setError(res.errorMessage);
      }else{
        setIsSubmitting(false);

      }
    

      
  }

    const countDown =()=>{
        let start = 59;
       
            setInterval(()=>{
                start-=1;
             return start;
    
            },1000)
          
        
     
    }

    function obsecurePhoneNumber(phone){
        const str1 = phone.substr(0,6);
        const str2 = phone.substr(-3,3);
        const obsecuredPhone = str1+"*****"+str2;
        return obsecuredPhone;


    }

  
    return(
        <div className="container">
            <div>
                {
                    isSuccess ?
                    <div style={{ textAlign: "center", fontFamily: "Arial, sans-serif" }}>
          <h2>Request Submitted</h2>
          <p>
            Your request to delete your personal data has been received. We will process
            your request within 7 business days. If you have any further questions, please
            contact us at <a href="mailto:support@mastakash.com">support@mastakash.com</a>.
          </p>
          <button
            onClick={onClose}
            style={{
              padding: "10px 20px",
              backgroundColor: "#007BFF",
              color: "#FFF",
              border: "none",
              borderRadius: "5px",
              cursor: "pointer",
            }}
          >
            Close
          </button>
        </div>
        :
        <div>

<Card className='text-center'>
    <Card.Title>
    <h3>Verify Phone Number</h3>
    </Card.Title>
    <Card.Body>
   
 <div className='row'>
    <div className='col-sm-3'>

    </div>
    <div className='col-sm-6'>
      {error !== null && <p style={{color:"red"}}>{error}</p>}
    <p>Verification code has been send to {obsecurePhoneNumber(msisdn)}.</p>
    {isSuccess && navigate(`/verify-email`)}

  <form  onSubmit={handleSubmit} className="form-group">
  <div className="form-group">
        <input type="text" className="form-control" name="verification_code" placeholder="Enter Verification Code"  onChange={handleChange} />
        {error !== null && <p className='text text-danger'>{error}</p>}

                            </div>

{
    verificationCode=== null ?
    <button type="submit" className="btn btn-success" disabled>{isSubmitting ? <CircularProgress/> : 'Verify'}</button>
    :
    <button type="submit" className="btn btn-success" >{isSubmitting ? <CircularProgress/> : 'Verify'}</button>
}
  </form>
  <div>

  <p>
                {canResend
                  ? "You can now resend the verification code."
                  : `Did not receive verification code? Resend in ${countdown} seconds.`}
              </p>
              <button
                onClick={handleResend}
                disabled={!canResend}
                className="btn btn-primary"
              >
                Resend Code
              </button>

  
  </div>
    </div>
    <div className='col-sm-3'>
        
    </div>
 </div>

    </Card.Body>
  </Card>
        </div>
                }

            </div>
  
</div>
    )
}
export default VerifyPhoneNumber;